import React from 'react'
import ReactMarkdown from 'react-markdown'

import MuiLink from '@mui/material/Link'
import CloseIcon from '@mui/icons-material/Close'

import Alert from '../components/alert/alert'
import { SystemMessageType } from '../types/enums/systemMessageType'
import { SystemMessage } from '../types/systemMessage'
import { get } from './service'
import TooltipIconButton from '../components/fields/tooltipIconButton'
import { getDismissedSystemMessages, setDismissedSystemMessages } from './localStorageUtils'

const SystemMessages = (): JSX.Element => {
  const [messages, setMessages] = React.useState<Array<SystemMessage>>([])
  const [dismissedMessages, setDismissedMessages] = React.useState<Array<string>>(getDismissedSystemMessages())

  React.useEffect(() => {
    const loadMessages = () => {
      get<Array<SystemMessage>>('systemmessages/?page_size=all').then((response) => setMessages(response.data))
    }
    setInterval(loadMessages, 1800000) // 30 min
    loadMessages()
  }, [])

  React.useEffect(() => {
    setDismissedSystemMessages(dismissedMessages)
  }, [dismissedMessages])

  const dismissMessage = (messageUrl: string) => {
    setDismissedMessages((oldMessages) => [...oldMessages, messageUrl])
  }

  const messageTypeToAlertType = (message: SystemMessage): 'error' | 'info' | 'warning' => {
    if (message.message_type === SystemMessageType.INFO) {
      return 'info'
    } else if (message.message_type === SystemMessageType.WARNING) {
      return 'warning'
    }
    return 'error'
  }

  return (
    <>
      {messages
        .filter((x) => dismissedMessages.indexOf(x.url) === -1)
        .map((x) => (
          <Alert
            key={x.url}
            severity={messageTypeToAlertType(x)}
            action={<TooltipIconButton onClick={() => dismissMessage(x.url)} icon={<CloseIcon />} tooltip="" />}
          >
            <ReactMarkdown
              components={{
                p(args) {
                  return <div>{args.children}</div>
                },
                a(args) {
                  return (
                    <MuiLink href={args.href} target="_blank">
                      {args.children}
                    </MuiLink>
                  )
                },
              }}
            >
              {x.message}
            </ReactMarkdown>
          </Alert>
        ))}
    </>
  )
}

export default SystemMessages
